export default __webpack_public_path__ + "static/media/Trial.b206eb26.svg";